export const getParcours = async (lang, parcours) => {
  const origin = process.env.PUBLIC_URL;
  const response = await fetch(`${origin}/${lang}/parcours-${parcours}.json`);
  if (!response.ok) {
    throw new Error("Failed to fetch parcours");
  }
  return response.json();
};
